import { Drawer, Skeleton } from 'antd'
import React, { Suspense } from 'react'

import { InstrumentCode } from '../../../models'
import { drawerAndModalWidth } from '../../../util/guideline'
import { UpdateManagedFund } from './UpdateManagedFund'
import { UpdateTrade } from './UpdateTrade'

interface UpdateTradeDrawerProps {
  tradeId: number
  instrumentCode: InstrumentCode
  domain: string
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const UpdateTradeDrawer = ({
  tradeId,
  instrumentCode,
  domain,
  isVisible,
  onSuccess,
  onClose,
}: UpdateTradeDrawerProps) => (
  <Drawer
    title="Update trade"
    placement="right"
    onClose={onClose}
    open={isVisible}
    width={drawerAndModalWidth}
    destroyOnClose
  >
    <Suspense fallback={<Skeleton />}>
      {instrumentCode === 'MGFUND' ? (
        <UpdateManagedFund tradeId={tradeId} domain={domain} onSuccess={onSuccess} />
      ) : (
        <UpdateTrade tradeId={tradeId} domain={domain} onSuccess={onSuccess} />
      )}
    </Suspense>
  </Drawer>
)
